import React, { useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import ProductCard from "./ProductCard";
import { getProductsByCategory } from "../../store/slices/products/asyncThunks";
import { selectProducts } from "../../store/slices/products/slice";

const ProductSlider = ({ category, excludeId }) => {
  const products = useSelector(selectProducts);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProductsByCategory({ id: category, page: 1 }))
      .unwrap()
      .then(() => {})
      .catch((err) => console.log(err.message));
  }, [category, dispatch]);

  const categoryData = (
    products.productsByCategory?.[category]?.data?.data || []
  )
    .filter((item) => item.id !== excludeId)
    .slice(0, 4);

  return categoryData.length > 0 ? (
    <Grid>
      {categoryData.map((product) => (
        <ProductCard product={product} small key={product.id} />
      ))}
    </Grid>
  ) : (
    <Empty>
      <span>無</span>
      Trenutno nema povezanih proizvoda iz ove kategorije.
    </Empty>
  );
};

export default ProductSlider;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1.8rem;
  width: 100%;
  margin-top: 2.4rem;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const Empty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  padding: 4rem 0;
  width: 100%;
  color: var(--muted, #8e8c94);
  font-size: 1.3rem;
  font-family: "Poppins-Medium";

  span {
    font-family: var(--font-kanji);
    font-size: 5rem;
    color: var(--muted2, #5c5a63);
    line-height: 1;
  }
`;
